import axios from '../../../helpers/custom-axios';

export const associatedMetadata = (entries, option) => {
  let entryContents = [];
  if (entries && option) {
    entries.forEach((e) => {
      let c;
      if (option.metadata_contents.length) {
        c = option.metadata_contents.find(
          (mc) => mc.metadata_entry_id == e.id
        ) || { description: '' };
      } else {
        c = { description: '' };
      }

      entryContents.push({ entry: e, content: c });
    });
  }
  return entryContents;
};

export const relatedResponse = (field, responses) => {
  let response = responses.find((r) => r.field_id === field.id);
  return response;
};

export const partitionFields = (fields) => {
  return fields.reduce((arr, f) => {
    let width = f.width;
    let prev = arr.pop() || [];
    let last = prev[prev.length - 1] || [];

    if (
      prev.length &&
      (prev.length >= width || (last.width && width != last.width))
    ) {
      arr.push(prev);
      arr.push([f]);
    } else {
      prev.push(f);
      arr.push(prev);
    }

    return arr;
  }, []);
};

export const fieldsetHasValidResponses = (fields, responses) => {
  let fieldsetResponses = responses.filter((r) =>
    fields.map((f) => f.id).includes(r.field_id)
  );
  return fieldsetResponses.some(
    (r) => r.value || r.response_options?.length || r.response_files?.length
  );
};

export const stickyHeader = () => {
  $(window).on('scroll', function () {
    if ($('.form.head').length) {
      const scrollTop = $(window).scrollTop();
      const offsetTop = $('.submission').offset().top;

      if (scrollTop - offsetTop > 0) {
        $('.form.head').addClass('fixed');
      } else {
        $('.form.head').removeClass('fixed');
      }
    }
  });
};

export const markSubmissionRead = async (submissionID) => {
  return axios
    .put(`/manage/submissions/${submissionID}`, {
      submission: { read: true },
    })
    .then((res) => {
      console.log('submission marked as read');
    })
    .catch((err) => {
      console.error(err);
    });
};

export const fetchDelivery = async (deliveryID) => {
  return axios
    .get(`/manage/deliveries/${deliveryID}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const linkedSubmissions = (submissionID, group) => {
  if (!group) return;

  let forms = group.group_forms.map((form) => {
    return {
      id: form.id,
      name: form.name,
      container_name: form.container_name,
      submission_ids: form.linked_subs.map((s) => s.id),
    };
  });

  let links = group.submission_groups.map((sg, i, arr) => {
    let form = forms.find((f) => f.submission_ids.includes(sg.submission_id));

    // provide relevant combined data
    return {
      submission_group: sg,
      submission_id: sg.submission_id,
      form,
      container_name: form.container_name,
      disabled: sg.submission_id == submissionID,
      isParent: sg.submission_id == group.parent_submission_id,
    };
  });

  // further format the data for easier rendering
  let tableData = {
    group: group,
    links: links.sort((a, b) => {
      if (a.isParent || b.isParent) {
        return a.isParent ? -1 : 1;
      }
      return (
        a.form.name.localeCompare(b.form.name) ||
        b.submission_group.submission_id - a.submission_group.submission_id
      );
    }),
  };
  return tableData;
};

export const linkedSubmissionsForMailer = (
  detectedForms,
  linkedSubmissions
) => {
  let linkedWillMail = [];
  let linkedFormsMissing = [];
  let linkedFormsPresent = [];
  if (detectedForms && linkedSubmissions.links) {
    let detectedFormIds = detectedForms.map((f) => f.id);
    // Only return the linked submissions per related form
    linkedWillMail = linkedSubmissions.links.filter((link) =>
      detectedFormIds.includes(link.form.id)
    );

    // Flag if the submission is missing a link from other forms used on the mailer
    let mailLinkedFormIDs = linkedWillMail.map((link) => link.form.id);
    linkedFormsPresent = detectedForms.filter((form) =>
      mailLinkedFormIDs.includes(form.id)
    );
    linkedFormsMissing = detectedForms.filter(
      (form) =>
        !mailLinkedFormIDs.includes(form.id) || !mailLinkedFormIDs.length
    );
  }
  return {
    linkedWillMail,
    linkedFormsMissing,
    linkedFormsPresent,
  };
};
